// extracted by mini-css-extract-plugin
export var auto = "_z-1";
export var spinner = "_z-0";